const closure = mainApp => {
    mainApp.setSlideParams = function() {
        mainApp.slides = [
            {
                type: 'text',
                title: 'Increasing Urbanization',
                text:
                    "In 2010, for the first time in history, over half of the world's population lived in an urban area. By 2030, it is predicted that five billion of the world's eight billion inhabitants will live in cities.",
                buttonText: ['Begin']
            },

            {
                type: 'graph',
                title: 'Increasing Urbanization',
                graph: mainApp.urbanRuralGraph,
                buttonText: ['Back', 'Next']
            },

            {
                type: 'text',
                title: 'Global Urbanization, 1950-2030',
                text:
                    "While virtually all cities in the world are growing, urbanization rates differ dramatically by region. Correspondingly, we are likely to see substantial variation in cities' resource needs and policy challenges.",
                buttonText: ['Back', 'Next']
            },

            {
                type: 'animation',
                startYear: 1950,
                endYear: 2030,
                duration: 80 * mainApp.params.msYear,
                delay: 0,
                transform: { k: 1, x: 0, y: 0 },
                buttonText: ['Back', 'Next']
            },

            {
                type: 'text',
                title: 'Urbanization in Africa and Asia, 2015-2030',
                text:
                    'Projected urbanization shows particularly large changes in Africa and Asia. Cities there will face a disproportionate increase in energy demands and pressures on existing urban resources.',
                buttonText: ['Back', 'Next']
            },

            {
                type: 'animation',
                startYear: 2015,
                endYear: 2030,
                duration: 50 * mainApp.params.msYear,
                delay: 600,
                transform: { k: 1.6, x: -548, y: -159 },
                buttonText: ['Back', 'Next']
            },

            {
                type: 'text',
                title: 'Explore the Visualization',
                text:
                    'Please explore the visualization on your own. You can drag the slider to see growth over time and click on any of the bubbles to see city names, regions, and populations. You may scroll to zoom in and see cities more closely. Note that each circle represents an urban agglomeration or metropolitan area.',
                buttonText: ['Back', 'Explore']
            },

            {
                type: 'animation',
                startYear: 2016,
                endYear: 2016,
                duration: 0,
                delay: 100,
                transform: { k: 1, x: 0, y: 0 },
                buttonText: ['Back', 'Restart']
            }
        ];
    };
};

export default closure;
